import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=9a93b008&scoped=true&lang=pug"
import script from "./Splash.vue?vue&type=script&lang=ts"
export * from "./Splash.vue?vue&type=script&lang=ts"
import style0 from "./Splash.vue?vue&type=style&index=0&id=9a93b008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a93b008",
  null
  
)

export default component.exports